const ITEM_ID_FIELDS = [
  'id',
  '_id',
  'userId',
  'studentId',
  'staffId',
  'schoolId',
  'tournamentId',
  'teamId',
  'eventId',
  'clubId',
  'permissionId'
];

export function getTwoPanelItemIdentity(item: any): string | undefined {
  if (!item) return undefined;

  for (const field of ITEM_ID_FIELDS) {
    const value = item[field];
    if (value !== undefined && value !== null && value !== '') {
      return String(value);
    }
  }

  return undefined;
}

export function isSameTwoPanelItem(first: any, second: any): boolean {
  if (first === second) return true;

  const firstIdentity = getTwoPanelItemIdentity(first);
  const secondIdentity = getTwoPanelItemIdentity(second);

  return Boolean(firstIdentity && secondIdentity && firstIdentity === secondIdentity);
}

export function findTwoPanelItemIndex(items: any[], item: any, fallbackIndex: number): number {
  const referenceIndex = items.indexOf(item);
  if (referenceIndex >= 0) return referenceIndex;

  const identityIndex = items.findIndex(candidate => isSameTwoPanelItem(candidate, item));
  return identityIndex >= 0 ? identityIndex : fallbackIndex;
}
